import { HttpClient } from '../shared/api/HttpClient';
import type { ManagedStation, StationCapacitySummary } from './types';

interface StationPage { items: ManagedStation[]; nextCursor: string | null }
interface ServerSummary { stations: StationCapacitySummary }

export class StationsApi {
  readonly #http: HttpClient;

  public constructor(http = new HttpClient({ readCsrfToken: readCsrfCookie })) {
    this.#http = http;
  }

  public async list(): Promise<ManagedStation[]> {
    return (await this.#http.request<StationPage>('/stations?limit=100')).items;
  }

  public async capacity(): Promise<StationCapacitySummary> {
    return (await this.#http.request<ServerSummary>('/monitoring/server')).stations;
  }

  public create(payload: {
    slug: string;
    name: string;
    timezone: string;
    schedulerHorizonMinutes: number;
    maxLiveGuests: number;
  }): Promise<ManagedStation> {
    return this.#http.request('/stations', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...payload,
        format: { codec: 'AAC_LC', bitrateKbps: 128, sampleRateHz: 48_000, channels: 2 },
      }),
    });
  }

  public setEnabled(station: ManagedStation, enabled: boolean): Promise<ManagedStation> {
    return this.#http.request(`/stations/${station.id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', 'If-Match': `"${station.revision}"` },
      body: JSON.stringify({ enabled }),
    });
  }
}

function readCsrfCookie(): string | null {
  const prefix = '__Host-radio_csrf=';
  const value = document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith(prefix));
  return value === undefined ? null : decodeURIComponent(value.slice(prefix.length));
}
